import ApiService from '../api.service';

const PrivacyPolicyResource = {
  current: () => ApiService.get('/v1/privacy_policies/current'),
};

export default PrivacyPolicyResource;
